module.exports = __webpack_public_path__ + "img/icon-file.99b5558a.svg";